import { orderBy } from 'lodash';
import { BuildTypeCode } from '../../../projects/project';
import { UnitHeatLossDetailsFormModel } from '../../quote-or-design-form/units/heatLoss/unitHeatLossDetailsFormModel';
import { mapUnitFloorElementResponseToFormModel, UnitFloorElementResponse } from './unitFloorElementResponse';
import { mapUnitRoofElementResponseToFormModel, UnitRoofElementResponse } from './unitRoofElementResponse';
import { mapUnitWallElementResponseToFormModel, UnitWallElementResponse } from './unitWallElementResponse';

export type UnitHeatLossDetailsResponse = {
  generalAllowanceFactorPercentage: number | null;
  exposureFactorPercentage: 0 | 10;
  propertyFootprintInMetresSquared: number | null;
  propertyExternalPerimeterInMetres: number | null;
  buildTypeCode: BuildTypeCode | null;
  externalAirTemperatureInDegreesCelsius: number | null;
  wallElements: Array<UnitWallElementResponse>;
  roofElements: Array<UnitRoofElementResponse>;
  floorElements: Array<UnitFloorElementResponse>;
};

export const mapUnitHeatLossDetailsResponseToFormModel = (
  response: UnitHeatLossDetailsResponse,
): UnitHeatLossDetailsFormModel => ({
  generalAllowanceFactorPercentage: response.generalAllowanceFactorPercentage?.toString() ?? '',
  exposureFactorPercentage: response.exposureFactorPercentage,
  propertyFootprintInMetresSquared: response.propertyFootprintInMetresSquared?.toString() ?? '',
  propertyExternalPerimeterInMetres: response.propertyExternalPerimeterInMetres?.toString() ?? '',
  buildTypeCode: response.buildTypeCode ?? 'NewBuild',
  externalAirTemperatureInDegreesCelsius: response.externalAirTemperatureInDegreesCelsius?.toString() ?? '',
  wallElements: orderBy(response.wallElements, wallElement => wallElement.displayIndex).map(
    mapUnitWallElementResponseToFormModel,
  ),
  roofElements: orderBy(response.roofElements, roofElement => roofElement.displayIndex).map(
    mapUnitRoofElementResponseToFormModel,
  ),
  floorElements: orderBy(response.floorElements, floorElement => floorElement.displayIndex).map(
    mapUnitFloorElementResponseToFormModel,
  ),
});
